// src/router/routes.tsx
import { lazy, Suspense, ComponentType, FC } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import RouteGuard from './RouteGuard';
import { PATHS } from './paths';

// Lazy load components
const Layout = lazy(() => import('../components/Layout'));
const NotFound: FC = () => <div>404 - Not Found</div>;
const Home = lazy(() => import('../pages/Home'));
const Login = lazy(() => import('../pages/Login'));
const Admin = lazy(() => import('../pages/Admin'));
const User = lazy(() => import('../pages/User'));
const UserDetail = lazy(() => import('../pages/User/Detail'));
const Help = lazy(() => import('../pages/Help'));
const HelpDetail = lazy(() => import('../pages/Help/Detail'));

// Loading spinner component
const LoadingSpinner: FC = () => <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;

// Suspense wrapper
function withSuspense(Component: ComponentType) {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  );
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <RouteGuard>{withSuspense(Layout)}</RouteGuard>,
    children: [
      {
        index: true,
        element: <Navigate to={PATHS.dashboard} replace />,
      },
      { path: PATHS.dashboard.slice(1), element: withSuspense(Home) },
      { path: PATHS.admins.slice(1), element: withSuspense(Admin) },
      { path: PATHS.users.slice(1), element: withSuspense(User) },
      { path: PATHS.userDetail.slice(1), element: withSuspense(UserDetail) },
      { path: PATHS.help.slice(1), element: withSuspense(Help) },
      { path: PATHS.helpDetail.slice(1), element: withSuspense(HelpDetail) },
    ],
  },
  {
    path: PATHS.login,
    element: withSuspense(Login),
  },
  {
    path: '*',
    element: <NotFound></NotFound>,
  },
];

export default routes;
